// import { useCallback, useEffect, useState } from 'react'
// import { useLocation } from 'react-router-dom';
// import { useInterval } from 'react-use';
// import { useAtom, useSetAtom } from 'jotai'

// import { HttpCode, Millisecond, STORAGE_KEY } from '@/constants/common'
// import { deleteUrlParams, getUrlParams } from '@/lib/utils'
// import { useGlobalMethodProviderContext } from '@/providers/GlobalMethodProvider'
// import { githubAuthStateAtom, userInfoAtom } from '@/stores/services'

// import useFetch, { Method, useMutation } from './useFetch'
// import { useToken } from './useLoginWallet'
// import { useUserInfo } from './useUserInfo'

import { Method, useMutation } from './useFetch'

export enum GithubAuthState {
  UN_KNOWN = 'UN_KNOWN',
  REDIRECTING = 'REDIRECTING',
  AUTHENTICATED = 'AUTHENTICATED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  EXPIRED = 'EXPIRED',
  OCCUPIED = 'OCCUPIED',
  FAILED = 'FAILED'
}

export const useGithubAuthCallback = () => {
  const { trigger, ...rest } = useMutation({
    url: '/task/github/auth/callback',
    method: Method.POST
  })

  return {
    trigger,
    ...rest
  }
}

export const useGetGithubAuthLink = () => {
  const { trigger, ...rest } = useMutation({
    url: '/task/github/auth/link',
    method: Method.POST
  })

  return {
    trigger,
    ...rest
  }
}

// export const useCheckGithubAuth = () => {
//   const { token } = useToken()
//   const [userInfo] = useAtom(userInfoAtom)

//   const [githubAuthState, setGithubAuthState] = useAtom(githubAuthStateAtom)

//   const { mutate } = useUserInfo()

//   useInterval(
//     () => {
//       mutate()
//     },
//     githubAuthState === GithubAuthState.REDIRECTING
//       ? Millisecond.SECOND_3
//       : null
//   )

//   useEffect(() => {
//     if (userInfo?.gid) {
//       setGithubAuthState(GithubAuthState.AUTHENTICATED)
//     } else {
//       setGithubAuthState(GithubAuthState.UNAUTHENTICATED)
//     }
//   }, [userInfo])

//   return {
//     trigger: mutate
//   }
// }

// export const useAuthCallback = () => {
//   const { token } = useToken()
//   const setGithubAuthState = useSetAtom(githubAuthStateAtom)
//   const { refreshUserInfo, openGithubAuth } = useGlobalMethodProviderContext() || {}
//   const [state, code, type] = [
//     getUrlParams('state'),
//     getUrlParams('code'),
//     getUrlParams('type')
//   ]
//   const isCallback = type === 'github'

//   const { data, ...rest } = useFetch<any>(
//     token && isCallback && state && code ? '/task/github/auth/callback' : null,
//     Method.POST,
//     { state, code },
//     {
//       onSuccess: (_, code) => {
//         deleteUrlParams(['state', 'code', 'type'])
//         if (code === 0) {
//           setGithubAuthState(GithubAuthState.AUTHENTICATED)
//           refreshUserInfo()
//         } else if (code === HttpCode.TwitterOccupied) {
//           setGithubAuthState(GithubAuthState.OCCUPIED)
//         } else {
//           setGithubAuthState(GithubAuthState.EXPIRED)
//         }
//       }
//     }
//   )

//   useEffect(() => {
//     if (isCallback && state && code) openGithubAuth?.()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   return {
//     state,
//     code,
//     data,
//     ...rest
//   }
// }

// export const useGetAuthLink = () => {
//   const { token } = useToken()
//   const [canFetch, setCanFetch] = useState(false)
//   const [, setGithubAuthState] = useAtom(githubAuthStateAtom)

//   const { mutate } = useFetch<{ authUrl: string }>(
//     token && canFetch ? '/task/github/auth/link' : null,
//     Method.POST,
//     { domainType: 1 },
//     {
//       onSuccess: (data) => {
//         if (!data.authUrl) return
//         setGithubAuthState(GithubAuthState.REDIRECTING)
//         window.localStorage.setItem(
//           STORAGE_KEY.BEFORE_AUTH_ROUTE,
//           location.pathname
//         )
//         location.href = data.authUrl
//         // window.open(
//         //   data.authUrl,
//         //   '_self',
//         //   'width=600,height=800,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
//         // )
//       }
//     }
//   )
//   const getAuthLink = useCallback(() => {
//     if (!canFetch) setCanFetch(true)
//     else {
//       mutate()
//     }
//   }, [canFetch, mutate])

//   return { getAuthLink }
// }

// export const useGithubAuth = () => {
//   const { getAuthLink } = useGetAuthLink()
//   const { state, code, isLoading, isValidating } = useAuthCallback()

//   return { state, code, checkLoading: isLoading || isValidating, getAuthLink }
// }
